const swiper09 = new Swiper('.content-responsive', {
    direction: 'horizontal',
    spaceBetween: 15,
    slidesPerView: 1.2,
    breakpoints: {
          769:{
              slidesPerView: 2,
          },
          426:{
              slidesPerView: 1.2,
          }
      }
})